const ACCESS_PREFIX = 'automation:'

const normalizeAccessIdentifiers = identifiers => {
  if (!Array.isArray(identifiers)) return identifiers

  return [...new Set(identifiers.flatMap(identifier => {
    if (typeof identifier !== 'string') return [identifier]

    const identifierWithoutPrefix = identifier.startsWith(ACCESS_PREFIX)
      ? identifier.slice(ACCESS_PREFIX.length)
      : identifier

    return [`${ACCESS_PREFIX}${identifierWithoutPrefix}`, identifierWithoutPrefix]
  }))]
}

export default {
  namespaced: true,
  state: {
    redirectFrom: null,
    data: null
  },
  getters: {},
  mutations: {
    UPDATE_USER_REDIRECT_FROM(state, data) {
      state.redirectFrom = data
    },
    UPDATE_USER_DATA(state, data) {
      state.data = data && {
        ...data,
        roles: normalizeAccessIdentifiers(data.roles),
        permissions: normalizeAccessIdentifiers(data.permissions),
      }
    },
  },
  actions: {},
}
